// extracted by mini-css-extract-plugin
module.exports = {"ratingPicker":"StarRating_ratingPicker__iumo_"};